
import { RouteLocationNormalizedLoaded } from '#vue-router'

export interface RouteMeta {
  title?: string
  category?: string
  isMain?: boolean
  to: RouteLocationRaw
}

const history: Ref<RouteLocationRaw[]> = ref([])
const historyMeta: Ref<RouteMeta[]> = ref([])

const isInit = ref(false)

export const useHistory = () => {
  const historyInit = async () => {
    const historyMetaCookie = await getCookie('history')

    if (historyMetaCookie) {
      historyMeta.value = historyMetaCookie as any
    } 

    isInit.value = true
  }

  const historyPush = async (route: RouteMeta) => {
    historyMeta.value = [
      route,
      ...historyMeta.value
    ].slice(0, 30)
    
    if (isInit.value) await setCookie('history', JSON.stringify(historyMeta.value))
  }

  const updateHistory = (
    route: RouteLocationNormalizedLoaded
  ) => {
    history.value = [
      {
        name: route.name as string,
        params: { ...route.params } as any,
        query: { ...route.query } as any,
      },
      ...history.value
    ].slice(0, 20)
  }
  
  const goBackToMain = (fallback: { name: string }, main?: string) => {
    const router = useRouter()
    const route = useRoute()

    // router.back()

    const prev = history.value.filter(r => {
      if (!(r?.name ?? '').includes(route.name as string) && !((route?.name ?? '') as string).includes(r.name) && !(r?.name ?? '').includes(main ?? '0')) return true

      if (JSON.stringify(r.params) !== JSON.stringify(route.params)) return true
      
      return false
    })[0]

    if (prev) {
      history.value = history.value.filter(r => {
        if (r.name === route.name && JSON.stringify(r?.params) === JSON.stringify(route.params)) return false

        return true
      })
    }
      
    return router.push(prev?.name ? { name: prev.name, params: prev.params, query: prev.query } : fallback)
  }

  return {
    history, historyMeta, historyPush, updateHistory, goBackToMain, historyInit
  }
}